// Lazy singleton loader for @ffmpeg/ffmpeg.
// The wasm core is fetched from a CDN on first use so we don't bloat the JS bundle.
// Uses the multi-threaded core when the browser supports SharedArrayBuffer,
// falls back to single-threaded otherwise.

import { FFmpeg } from "@ffmpeg/ffmpeg";
import { toBlobURL } from "@ffmpeg/util";

let _ffmpeg = null;
let _loading = null;

const CORE_VERSION = "0.12.6";
const CORE_BASE = `https://unpkg.com/@ffmpeg/core@${CORE_VERSION}/dist/umd`;

export function isFFmpegReady() {
  return !!(_ffmpeg && _ffmpeg.loaded);
}

export async function getFFmpeg(onProgress) {
  if (_ffmpeg && _ffmpeg.loaded) return _ffmpeg;
  if (_loading) return _loading;

  _loading = (async () => {
    const ffmpeg = new FFmpeg();
    if (typeof onProgress === "function") {
      ffmpeg.on("progress", ({ progress }) => onProgress(Math.max(0, Math.min(1, progress || 0))));
    }
    await ffmpeg.load({
      coreURL: await toBlobURL(`${CORE_BASE}/ffmpeg-core.js`, "text/javascript"),
      wasmURL: await toBlobURL(`${CORE_BASE}/ffmpeg-core.wasm`, "application/wasm"),
    });
    _ffmpeg = ffmpeg;
    return ffmpeg;
  })();
  try {
    return await _loading;
  } finally {
    _loading = null;
  }
}
